(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-view.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-view.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;
const {
  PixMixImage
} = svs.pix_mix.components.pixmixView;
const {
  getProductConfigData
} = svs.components.lbUtils.brandMapping.fn;
const {
  MALTIPSET
} = svs.utils.products.productIds;

const PixmixView = _ref => {
  var _svs$pix_mix$data, _svs;
  let {
    className,
    draws = [],
    refreshDraws
  } = _ref;
  const {
    ingress,
    image: cmsImage,
    title
  } = ((_svs$pix_mix$data = svs.pix_mix.data) === null || _svs$pix_mix$data === void 0 ? void 0 : _svs$pix_mix$data.initialState) || {};
  let closestRegClose;

  const bundles = (((_svs = svs) === null || _svs === void 0 || (_svs = _svs.cmsData) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 ? void 0 : _svs.pixmix) || []).map(bundle => _objectSpread(_objectSpread({}, bundle), {}, {
    products: bundle.products.map(product => {
      const {
        drawNumber,
        regCloseTime
      } = draws.find(draw => draw.productId === product.id) || {};
      const currentCloseTime = new Date(regCloseTime);
      if (!closestRegClose || currentCloseTime < closestRegClose) {
        closestRegClose = currentCloseTime;
      }
      return _objectSpread(_objectSpread({}, product), {}, {
        systemCost: parseInt(product.systemSize, 10),
        systemType: product.id === MALTIPSET ? 'SROW' : 'MSYS',
        rowPrice: product.id === MALTIPSET ? 2.5 : 1,
        branding: getProductConfigData(product.id),
        drawNumber
      });
    })
  }));

  const showInfoDialog = e => {
    const dialog = new svs.ui.dialog.Contextual({
      area: svs.ui.dialog.area.CONTEXTUAL,
      branding: svs.ui.dialog.branding.SPORT,
      attachTo: e.target.closest('button'),
      title: '',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: ingress
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  return React.createElement("div", {
    className: "".concat(className, " pix-mix-view")
  }, title && React.createElement("h2", {
    className: "pix-mix-title"
  }, title, ingress && React.createElement(IconButton, {
    className: "pix-mix-info-btn qa-pix-mix-info",
    onClick: showInfoDialog
  }, React.createElement(Icon, {
    icon: "information",
    size: "300"
  }))), cmsImage && React.createElement(PixMixImage, null), React.createElement(svs.pix_mix.components.PixmixJackpot, {
    draws: draws
  }), React.createElement(svs.pix_mix.components.PixmixCountdown, {
    to: closestRegClose || new Date()
  }), React.createElement(svs.pix_mix.components.PixmixTabView, {
    bundles: bundles,
    refreshDraws: refreshDraws
  }));
};
setGlobal('svs.pix_mix.components.pixmixView.PixmixView', PixmixView);

 })(window);